import { makeStyles } from "@material-ui/core";

// The FULL "IMPLEMENT CONSULTING GROUP_" lockup, for the open drawer — LogoIcon keeps the condensed
// `IM_` for the collapsed 72px rail, where this does not fit. See theme.ts for why the full lockup.
//
// Built as styled text because no Implement logo artwork exists in this repo.
//
// Color comes from `palette.navigation.color`, never a literal: it is the sidebar's own foreground in
// both themes, and a hardcoded white is invisible against the light nav.
const useStyles = makeStyles((theme) => ({
	root: {
		display: "block",
		fontFamily: "Arial, Helvetica, sans-serif",
		fontWeight: "bold",
		color: theme.palette.navigation.color,
		lineHeight: 1.1,
	},
	name: {
		display: "block",
		fontSize: "1.05rem",
		letterSpacing: "0.04em",
	},
	descriptor: {
		display: "block",
		fontSize: "0.5rem",
		letterSpacing: "0.13em",
	},
	// The trailing underscore is the brand's signature element, picked out in the lead color.
	signature: {
		color: theme.palette.primary.main,
	},
}));

const LogoFull = () => {
	const classes = useStyles();

	return (
		<span className={classes.root}>
			<span className={classes.name}>IMPLEMENT</span>
			<span className={classes.descriptor}>
				CONSULTING GROUP<span className={classes.signature}>_</span>
			</span>
		</span>
	);
};

export default LogoFull;
